import React, { ReactNode } from 'react';
import { UserStatus } from '@vis-auth/vis-user-client';
import { Tag } from '@ver-uds/react';

interface Props {
  status: UserStatus;
  className?: string;
}

const StatusTag = ({ status, className }: Props): JSX.Element => {
  const generateStatusTag = (): ReactNode => {
    const userStatusDisplay = status.replace(/_/g, ' ');
    switch (status) {
      case UserStatus.ACTIVE:
        return (
          <Tag variant="success" className={className}>
            {userStatusDisplay}
          </Tag>
        );

      case UserStatus.LOCKED:
        return (
          <Tag variant="error" className={className}>
            {userStatusDisplay}
          </Tag>
        );
      case UserStatus.PASSWORDCHANGEREQUIRED:
        return (
          <Tag variant="warning" className={className}>
            {userStatusDisplay}
          </Tag>
        );
      case UserStatus.PENDINGREACTIVATION:
        return (
          <Tag variant="primary" className={className}>
            {userStatusDisplay}
          </Tag>
        );
      case UserStatus.PENDINGACTIVATION:
        return (
          <Tag variant="warning-lighter" className={className}>
            {userStatusDisplay}
          </Tag>
        );
      default:
        return <Tag className={className}>{userStatusDisplay}</Tag>;
    }
  };
  return <>{generateStatusTag()}</>;
};

StatusTag.defaultProps = {
  className: '',
};

export default StatusTag;
